import React, { Fragment } from "react";
import { X, Send, File } from "lucide-react";

const isImageFile = (file) => file?.type?.startsWith("image/");
const formatFileSize = (size) => {
    if (!size) return "0 B";
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (
        (size / Math.pow(1024, i)).toFixed(2) + " " + ["B", "KB", "MB", "GB", "TB"][i]
    );
};

const PreviewDialog = ({
    showPreviewDialog,
    fileToUpload,
    handleCancelFileUpload,
    fetchUploadFileApi,
    color = "#000",
}) => {
    if (!showPreviewDialog) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 9999,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    borderRadius: "0.5rem",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                    maxWidth: "32rem",
                    width: "100%",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "1rem",
                        borderBottom: "1px solid #e5e7eb",
                    }}
                >
                    <h2 style={{ fontSize: "1.125rem", fontWeight: "600" }}>Preview</h2>
                    <button
                        onClick={handleCancelFileUpload}
                        style={{
                            color: "#6b7280",
                            cursor: "pointer",
                        }}
                    >
                        <X size={24} />
                    </button>
                </div>

                <div style={{ padding: "1rem" }}>
                    {fileToUpload && (
                        <Fragment>
                            {isImageFile(fileToUpload) ? (
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <img
                                        src={URL.createObjectURL(fileToUpload)}
                                        alt="Preview"
                                        style={{
                                            maxHeight: "16rem",
                                            borderRadius: "0.5rem",
                                        }}
                                    />
                                </div>
                            ) : fileToUpload.type.startsWith("video/") ? (
                                <video
                                    controls
                                    style={{
                                        width: "100%",
                                        maxHeight: "16rem",
                                        borderRadius: "0.5rem",
                                    }}
                                    src={URL.createObjectURL(fileToUpload)}
                                />
                            ) : fileToUpload.type.startsWith("audio/") ? (
                                <audio
                                    controls
                                    style={{ width: "100%" }}
                                    src={URL.createObjectURL(fileToUpload)}
                                />
                            ) : fileToUpload.type === "application/pdf" ? (
                                <iframe
                                    src={URL.createObjectURL(fileToUpload)}
                                    style={{
                                        width: "100%",
                                        height: "16rem",
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "0.5rem",
                                    }}
                                    title="PDF Preview"
                                />
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        backgroundColor: "#f3f4f6",
                                        padding: "1rem",
                                        borderRadius: "0.5rem",
                                    }}
                                >
                                    <File
                                        size={32}
                                        style={{ color: "#374151", marginRight: "0.75rem" }}
                                    />
                                    <div>
                                        <p style={{ fontWeight: "500" }}>{fileToUpload?.name}</p>
                                        <p style={{ fontSize: "0.875rem", color: "#6b7280" }}>
                                            {formatFileSize(fileToUpload?.size)}
                                        </p>
                                        <a
                                            href={URL.createObjectURL(fileToUpload)}
                                            download={fileToUpload.name}
                                            style={{
                                                color: "#2563eb",
                                                fontSize: "0.875rem",
                                                marginTop: "0.25rem",
                                                display: "inline-block",
                                            }}
                                        >
                                            Download file
                                        </a>
                                    </div>
                                </div>
                            )}
                        </Fragment>
                    )}
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "1rem",
                        borderTop: "1px solid #e5e7eb",
                    }}
                >
                    <button
                        onClick={handleCancelFileUpload}
                        style={{
                            padding: "0.5rem 1rem",
                            color: "#374151",
                            marginRight: "0.5rem",
                            borderRadius: "0.375rem",
                            backgroundColor: "transparent",
                            cursor: "pointer",
                        }}
                        onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#f3f4f6")
                        }
                        onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "transparent")
                        }
                    >
                        Cancel
                    </button>
                    <button
                        onClick={fetchUploadFileApi}
                        style={{
                            padding: "0.5rem 1rem",
                            color: "#fff",
                            borderRadius: "0.375rem",
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: color,
                            cursor: "pointer",
                        }}
                    >
                        <Send size={18} style={{ marginRight: "0.25rem" }} />
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PreviewDialog;
